import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { ScreeningTestFrequencyOption } from "@/Common/Models/UI/Inputs/DropDownOption";
import { MedicalItemScreeningTest } from "@/Patient/Models/MedicalSummary/MedicalItemScreeningTest";
import { MedicalItemScreeningTestResponse } from "@/Patient/Models/MedicalSummary/Response/MedicalItemScreeningTestResponse";
import { IPatientMedicalSummaryModel } from "@/Patient/Models/UI/MedicalSummary/IPatientMedicalSummaryModel";

import styles from "./PreventiveActivitySection.module.css";

interface IPreventiveActivitySectionProps {
    model: IPatientMedicalSummaryModel;
    onMedicalItemClick: (model: MedicalItemScreeningTestResponse, view: MedicalItemsTab) => void;
}

function PreventiveActivitySection(props: IPreventiveActivitySectionProps): JSX.Element {
    return (
        <>
            {MedicalItemScreeningTest.getLatestScreeningsToDisplay(props.model)?.map(
                element => (
                    <a
                        key={`preventive_activity_${element.model.Id}`}
                        className={styles.item}
                        onClick={() => props.onMedicalItemClick(element.model, MedicalItemsTab.ScreeningTest)}
                    >
                        <span className={styles.frequency}>
                            {element.model.FrequencyTypeDropDownId ? ScreeningTestFrequencyOption.fromDropDownId(element.model.FrequencyTypeDropDownId)?.getNameAbbr?.() : "--"}
                        </span>
                        <span className={styles.definition}>{element.getScreeningTestTitle()}</span>
                        <span className={styles.status}>{element.getStatusLocalizedValue()}</span>
                    </a>
                )
            )}
        </>
    );
}

export { PreventiveActivitySection };
